export default __webpack_public_path__ + "media/technology-arrow.9c0f64c9.png";